import PedidoMaterialNovo from './PedidoMaterialNovo';

export default PedidoMaterialNovo;